import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: '1rem',
    width: '32px',
    height: '32px'
  },

  right: {
    width: 'calc(100% - 1rem)',

    textAlign: 'right'
  },

  exp: {
    opacity: '0.35',
    fontStyle: 'italic'
  }
}))

export default useStyles
